import { render, staticRenderFns } from "./Workcg.vue?vue&type=template&id=68711db0&scoped=true"
import script from "./Workcg.vue?vue&type=script&lang=js"
export * from "./Workcg.vue?vue&type=script&lang=js"
import style0 from "./Workcg.vue?vue&type=style&index=0&id=68711db0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68711db0",
  null
  
)

export default component.exports